module.exports = __webpack_public_path__ + "static/media/rocket.93939102.svg";